import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DailyStatsTableCard from 'components/DailyStatsTableCard';
import Simplebar from 'components/Simplebar';
import React from 'react';

import { DomainStatsData } from '../../types';
import columns, { defaultSort } from './utils';

interface SiteUniqueEngagementTableProps {
  domainStats: DomainStatsData;
}

const SiteUniqueEngagementTable: React.FunctionComponent<
  SiteUniqueEngagementTableProps
> = (props) => {
  const { domainStats } = props;

  return (
    <Card>
      <CardContent component={Simplebar}>
        <DailyStatsTableCard
          columns={columns}
          dailyStats={{
            data: domainStats.data,
            loading: domainStats.loading,
            error: domainStats.error,
          }}
          defaultSort={defaultSort}
          showFooter={false}
          showHeader={false}
          tableLayout="fixed"
        />
      </CardContent>
    </Card>
  );
};

export default SiteUniqueEngagementTable;
